var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43903 9.52439C2.43903 5.88739 5.38739 2.93903 9.02439 2.93903C12.6614 2.93903 15.6098 5.88739 15.6098 9.52439C15.6098 11.2925 14.913 12.8978 13.779 14.0808C13.7428 14.1096 13.7078 14.1408 13.6743 14.1743C13.6408 14.2078 13.6096 14.2427 13.5808 14.279C12.3979 15.413 10.7925 16.1098 9.02439 16.1098C5.38739 16.1098 2.43903 13.1614 2.43903 9.52439ZM14.4851 16.7097C12.969 17.8637 11.0767 18.5488 9.02439 18.5488C4.04036 18.5488 0 14.5084 0 9.52439C0 4.54036 4.04036 0.5 9.02439 0.5C14.0084 0.5 18.0488 4.54036 18.0488 9.52439C18.0488 11.5767 17.3637 13.469 16.2098 14.9851L19.6428 18.4182C20.1191 18.8944 20.1191 19.6666 19.6428 20.1428C19.1666 20.6191 18.3944 20.6191 17.9182 20.1428L14.4851 16.7097Z",
    fill: "#F0AB2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.050c58e9.svg";
export { ForwardRef as ReactComponent };